(function () {
  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }

  function addShippingDays(startDate, days, skipWeekends) {
    var date = new Date(startDate.getTime());
    var remaining = Math.max(0, days);

    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      if (!skipWeekends || !isWeekend(date)) {
        remaining -= 1;
      }
    }

    if (skipWeekends) {
      while (isWeekend(date)) {
        date.setDate(date.getDate() + 1);
      }
    }

    return date;
  }

  function part(date, locale, options) {
    return new Intl.DateTimeFormat(locale || 'en', options).format(date);
  }

  function formatDate(date, format, locale) {
    var output = format || '%a, %b %-d';
    var replacements = {
      '%A': part(date, locale, { weekday: 'long' }),
      '%a': part(date, locale, { weekday: 'short' }),
      '%B': part(date, locale, { month: 'long' }),
      '%b': part(date, locale, { month: 'short' }),
      '%Y': String(date.getFullYear()),
      '%y': String(date.getFullYear()).slice(-2),
      '%m': String(date.getMonth() + 1).padStart(2, '0'),
      '%-m': String(date.getMonth() + 1),
      '%d': String(date.getDate()).padStart(2, '0'),
      '%-d': String(date.getDate())
    };

    Object.keys(replacements)
      .sort(function (a, b) { return b.length - a.length; })
      .forEach(function (token) {
        output = output.split(token).join(replacements[token]);
      });

    return output;
  }

  function hydrate(root) {
    var target = root.querySelector('[data-pdp-shipping-date]');
    if (!target) return;

    var now = new Date();
    var days = toNumber(root.dataset.days, 0);
    var cutoffHour = toNumber(root.dataset.cutoffHour, 14);
    var skipWeekends = root.dataset.skipWeekends === 'true';

    if (now.getHours() >= cutoffHour) {
      days += 1;
    }

    var estimate = addShippingDays(now, days, skipWeekends);
    target.textContent = formatDate(estimate, root.dataset.dateFormat, root.dataset.locale);
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function updatePeninsulaShipping(cartTotal) {
    document.querySelectorAll('[data-peninsula-free-shipping-goal]').forEach(function (root) {
      var target = root.querySelector('[data-peninsula-shipping-status]');
      if (!target) return;

      var goal = toNumber(root.dataset.peninsulaFreeShippingGoal, 10000);
      var currency = root.dataset.currency;
      var remaining = Math.max(0, goal - cartTotal);
      var message = cartTotal >= goal
        ? '· envío gratis para tu carrito'
        : cartTotal > 0
          ? '· te faltan ' + formatMoney(remaining, currency) + ' para envío gratis'
          : '· gratis desde ' + formatMoney(goal, currency);

      target.textContent = message;
    });
  }

  function refreshPeninsulaShipping() {
    if (!document.querySelector('[data-peninsula-free-shipping-goal]')) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) { updatePeninsulaShipping(cart.total_price || 0); })
      .catch(function () { /* Keep the server-rendered threshold if the cart is unavailable. */ });
  }

  function init() {
    document.querySelectorAll('[data-pdp-shipping-estimate]').forEach(hydrate);
    refreshPeninsulaShipping();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
  document.addEventListener('cart:updated', refreshPeninsulaShipping);
})();
